module.exports = __webpack_public_path__ + "static/media/font_medium.f2708ff0.woff2";